import { DateTimeHelper } from '../../../../helpers/date-time.helper';
import { TransportModeHelper } from '../../../../helpers/transport-mode.helper';
import { TransportSubModeHelper } from '../../../../helpers/transport-sub-mode.helper';
import type { IDestinationLink } from '../../../../models/destination-link.model';
import type { INote } from '../../../../models/note.model';
import { CoordinateApiModel } from '../coordinate.api-model';
import { LinkEndpointApiModel } from './link-endpoint.api-model';
import { LinkSegmentApiModel } from './link-segment.api-model';

export class DestinationLinkApiModel {
  public static mapToBusinessModel(apiModel: DestinationLinkApiModel): IDestinationLink {
    function parseDateTime(dateTimeString: string | undefined) {
      return dateTimeString ? DateTimeHelper.parse(dateTimeString) : undefined;
    }

    return {
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      transportSubMode: TransportSubModeHelper.parse(apiModel.transportSubMode),
      origin: LinkEndpointApiModel.mapToBusinessModel(apiModel.origin),
      destination: LinkEndpointApiModel.mapToBusinessModel(apiModel.destination),
      notes: apiModel.notes,
      distanceInMeters: apiModel.distanceInMeters,
      plannedDepartureTime: parseDateTime(apiModel.plannedDepartureTime),
      plannedArrivalTime: parseDateTime(apiModel.plannedArrivalTime),
      plannedDurationInMinutes: apiModel.plannedDurationInMinutes,
      estimatedDepartureTime: parseDateTime(apiModel.estimatedDepartureTime),
      estimatedArrivalTime: parseDateTime(apiModel.estimatedArrivalTime),
      estimatedDurationInMinutes: apiModel.estimatedDurationInMinutes,
      estimatedNumberOfSteps: apiModel.estimatedNumberOfSteps,
      linkCoordinates: apiModel.linkCoordinates,
    };
  }

  transportMode!: string;
  transportSubMode!: string;
  origin!: LinkEndpointApiModel;
  destination!: LinkEndpointApiModel;
  notes?: INote[];
  distanceInMeters?: number;
  plannedDepartureTime?: string;
  plannedArrivalTime?: string;
  plannedDurationInMinutes?: number;
  estimatedDepartureTime?: string;
  estimatedArrivalTime?: string;
  estimatedDurationInMinutes?: number;
  estimatedNumberOfSteps?: number;
  linkCoordinates?: CoordinateApiModel[];
  segments?: LinkSegmentApiModel[];
}
